module.exports = __webpack_public_path__ + "img/Bitmap3.81f2dda9.png";